import Root from '@/Root';
import CallbackRootLayout from '@/components/layouts/CallbackRootLayout';
import FlexRootlayout from '@/components/layouts/FlexRootLayout';
import OrderRootLayout from '@/components/layouts/OrderRootLayout';
import PCRootLayout from '@/components/layouts/PCRootLayout';
import Rootlayout from '@/components/layouts/Rootlayout';
import AdminPage from '@/pages/AdminPage';
import ChangeMarketPasswordPage from '@/pages/ChangeMarketPasswordPage';
import ErrorPage from '@/pages/ErrorPage';
import FunctionGuidePage from '@/pages/FunctionGuidePage';
import HomePage from '@/pages/HomePage';
import InquiryDetailPage from '@/pages/Inquiry/InquiryDetailPage';
import InquiryGuidePage from '@/pages/Inquiry/InquiryGuidePage';
import InquiryListPage from '@/pages/Inquiry/InquiryListPage';
import TemplatesInquiryDetail from '@/pages/Inquiry/TemplatesInquiryDetail';
import TemplatesInquiryList from '@/pages/Inquiry/TemplatesInquiryList';
import KakaoCallback from '@/pages/KakaoCallback';
import KakaoPayApprovalPage from '@/pages/KakaoPayApprovalPage';
import KakaoPayCancelPage from '@/pages/KakaoPayCancelPage';
import KakaopayChangeApproval from '@/pages/KakaopayChangeApproval';
import { AIChatBotPage, ChangeNamePage, MakeNamePage } from '@/pages/Lab';
import MarketConnectionCompletePage from '@/pages/MarketConnectionComplete';
import PcMarketConnectinoComplete from '@/pages/MarketConnectionComplete/PcMarketConnectinoComplete';
import MarketCorrectionPage from '@/pages/MarketCorrectionPage';
import MarketPage from '@/pages/MarketPage';
import MarketRegisterPage from '@/pages/MarketRegisterPage';
import MembershipPage from '@/pages/MembershipPage';
import MonitoringPage from '@/pages/MonitoringPage';
import MorePage from '@/pages/MorePage';
import MyProfilePage from '@/pages/MyProfilePage';
import { NewsBriefingPage } from '@/pages/NewsBriefing';
import OrderDetailsPage from '@/pages/OrderDetailsPage';
import OrdersPage from '@/pages/OrdersPage';
import PCInquiryListPage from '@/pages/PCInquiryListPage';
import PcMembership from '@/pages/PcMembership';
import ProductShipmentGuidePage from '@/pages/ProductShipmentGuidePage';
import ProductShipmentPage from '@/pages/ProductShipmentPage';
import { NaverRegisterStartPage } from '@/pages/RegisterMarket/naver-register-start-page';
import ReqAddMarketPage from '@/pages/ReqAddMarketPage';
import ReviewsPage from '@/pages/ReviewsPage';
import SignInPage from '@/pages/SignInPage';
import SignUpPage from '@/pages/SignUpPage';
import StatisticsPc from '@/pages/StatisticsPc';
import TestPage from '@/pages/TestPage';
import DiscoverMain from '@/pages/V3/Discover/DiscoverMain';
import HighAndLowCategoryList from '@/pages/V3/Discover/HighAndLow/HighAndLowCategoryList';
import HighAndLowGame from '@/pages/V3/Discover/HighAndLow/HighAndLowGame';
import HighAndLowRanking from '@/pages/V3/Discover/HighAndLow/HighAndLowRanking';
import HighAndLowResult from '@/pages/V3/Discover/HighAndLow/HighAndLowResult';
import HighAndLowStart from '@/pages/V3/Discover/HighAndLow/HighAndLowStart';
import StatisticsMain from '@/pages/V3/Statistics/StatisticsMain';
import YearEndPage from '@/pages/YearEndPage';
import { ResetPasswordPage } from '@/pages/reset-password-page';
import { UpdateAccountPage } from '@/pages/update-account-page';
import { UpdateInfoPage } from '@/pages/update-info-page';
import { wrapCreateBrowserRouter } from '@sentry/react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import { NaverRegisterTokenPage } from '@/pages/RegisterMarket/naver-register-token-page';
import { SmartstoreGuidePage } from '@/pages/guide/smartstore-guide-page';
import { IntroPage } from '@/pages/intro/intro-page';
import MarketRegisterMarketName from '@/pages/RegisterMarket/market-register-marketName';
import Cafe24RegisterStart from '@/pages/RegisterMarket/cafe-24-register-start-page';
import ImwebRegisterStartPage from '@/pages/RegisterMarket/imweb-register-start-page';
import ShopbyRegisterStartPage from '@/pages/RegisterMarket/shopby-register-start-page';
import SurveyPage from '@/pages/Survey/SurveyPage';
import { ROUTES } from './paths';
export { ROUTES } from './paths';

// sentry를 통한 라우팅 오류 및 성능 추적
const sentryCreateBrowserRouter = wrapCreateBrowserRouter(createBrowserRouter);

export const router = sentryCreateBrowserRouter([
  {
    Component: Root,
    path: ROUTES.root,
    errorElement: <ErrorPage />,
    children: [
      {
        element: <PCRootLayout />, // 새 PC 메인용 레이아웃
        children: [
          {
            path: ROUTES.dashboard,
            element: <HomePage />,
          },
        ],
      },
      {
        element: <PCRootLayout />, // 새 PC 메인용 레이아웃
        children: [
          {
            path: '/test',
            element: <TestPage />,
          },
        ],
      },
      {
        element: <CallbackRootLayout />, // 카카오 로그인 콜백용 레이아웃
        children: [
          {
            path: ROUTES.kakaoCallback,
            index: true, // 루트 경로에 해당
            element: <KakaoCallback />,
          },
        ],
      },

      {
        element: <PCRootLayout />, // 새 PC 메인용 레이아웃
        children: [
          {
            path: ROUTES.statistics,
            index: true, // 루트 경로에 해당
            element: <StatisticsPc />,
          },
        ],
      },
      {
        element: <OrderRootLayout />, // 새 PC 메인용 레이아웃
        children: [
          {
            path: `${ROUTES.PcMarketConnectinoComplete}/:englishMarketName`,
            index: true, // 루트 경로에 해당
            element: <PcMarketConnectinoComplete />,
          },
        ],
      },
      {
        element: <PCRootLayout />, // 새 PC 메인용 레이아웃
        children: [
          {
            path: ROUTES.PcMemberShip,
            index: true, // 루트 경로에 해당
            element: <PcMembership />,
          },
        ],
      },
      {
        element: <PCRootLayout />, // 새 PC 메인용 레이아웃
        children: [
          {
            path: '/kakaopayApproval',
            element: <KakaoPayApprovalPage />,
          },
          {
            path: '/kakaopayCancellation',
            element: <KakaoPayCancelPage />,
          },
          {
            path: ROUTES.kakaoPayChangeApproval,
            element: <KakaopayChangeApproval />,
          },
        ],
      },
      {
        element: <OrderRootLayout />, // 기존 레이아웃
        children: [
          {
            path: ROUTES.monitoring,
            index: true, // 루트 경로에 해당
            element: <MonitoringPage />,
          },
        ],
      },
      // 마켓 연동
      { path: ROUTES.marketConnectMarketName, element: <MarketRegisterMarketName /> },
      { path: ROUTES.cafe24RegisterStart, element: <Cafe24RegisterStart /> },
      { path: ROUTES.imwebRegisterStart, element: <ImwebRegisterStartPage /> },
      { path: ROUTES.shopbyRegisterStart, element: <ShopbyRegisterStartPage /> },

      {
        element: <OrderRootLayout />, // 새 PC 메인용 레이아웃
        children: [
          {
            path: ROUTES.market,
            element: <MarketPage />,
          },
          {
            path: `${ROUTES.marketRegister}/:marketName`,
            element: <MarketRegisterPage />,
          },
          { path: ROUTES.updateInfo, element: <UpdateInfoPage /> },
        ],
      },
      {
        element: <OrderRootLayout />, // 새 PC 메인용 레이아웃
        children: [
          {
            path: `${ROUTES.reqAddMarket}`,
            element: <ReqAddMarketPage />,
          },
        ],
      },

      {
        element: <OrderRootLayout />, // 새 PC 메인용 레이아웃
        children: [
          {
            path: `${ROUTES.changePassword}/:marketName`,
            element: <ChangeMarketPasswordPage />,
          },
        ],
      },
      {
        element: <OrderRootLayout />, // 새 PC 메인용 레이아웃
        children: [
          {
            path: `${ROUTES.more}`,
            element: <MorePage />,
          },
        ],
      },

      {
        element: <OrderRootLayout />, // 새 PC 메인용 레이아웃
        children: [
          {
            path: `${ROUTES.marketCorrection}/:marketName`,
            element: <MarketCorrectionPage />,
          },
        ],
      },

      {
        element: <OrderRootLayout />,
        children: [
          {
            path: 'orders',
            element: <OrdersPage />,
            children: [
              {
                index: true,
                element: <Navigate to="order-details" replace />,
              },
              {
                path: 'order-details',
                element: <OrderDetailsPage />,
              },
              {
                path: 'reviews',
                element: <ReviewsPage />,
              },
              {
                path: 'inquiries',
                element: <PCInquiryListPage />,
              },
            ],
          },
        ],
      },
      {
        element: <Rootlayout bgColor="bg-white" />,
        children: [
          {
            element: <ProtectedRoute />,
            children: [
              {
                path: ROUTES.inquiryHistory,
                element: <Navigate to="/more?ctab=support&chistory=true" replace />,
              },
              {
                path: ROUTES.inquiry,
                element: <Navigate to="/more?ctab=support" replace />,
              },
            ],
          },
        ],
      },
      {
        element: <Rootlayout />,
        children: [
          {
            element: <ProtectedRoute />,
            children: [
              // {
              //   path: ROUTES.reqAddMarket,
              //   element: <ReqAddMarketPage />,
              // },

              // {
              //   path: `${ROUTES.changePassword}/:marketName`,
              //   element: <ChangeMarketPasswordPage />,
              // },
              {
                path: ROUTES.myProfile,
                element: <MyProfilePage />,
              },
              {
                path: ROUTES.productShipment,
                element: <ProductShipmentPage />,
              },
              {
                path: ROUTES.productShipmentGuide,
                element: <ProductShipmentGuidePage />,
              },
              {
                path: ROUTES.functionGuide,
                element: <FunctionGuidePage />,
              },
              {
                path: ROUTES.admin,
                element: <AdminPage />,
              },
              {
                path: ROUTES.membership,
                element: <MembershipPage />,
              },
              {
                path: ROUTES.inquiryList,
                element: <InquiryListPage />,
              },
              {
                path: ROUTES.inquiryDetail,
                element: <InquiryDetailPage />,
              },
              {
                path: ROUTES.inquiryGuide,
                element: <InquiryGuidePage />,
              },
              {
                path: ROUTES.templatesInquiryList,
                element: <TemplatesInquiryList />,
              },
              {
                path: ROUTES.templatesInquiryDetail,
                element: <TemplatesInquiryDetail />,
              },
              /** V3 */
              // 발견
              {
                path: ROUTES.discoverMain,
                element: <DiscoverMain />,
              },

              {
                path: ROUTES.highAndLowStart,
                element: <HighAndLowStart />,
              },
              {
                path: ROUTES.highAndLowCategoryList,
                element: <HighAndLowCategoryList />,
              },
              {
                path: ROUTES.highAndLowGame,
                element: <HighAndLowGame />,
              },
              {
                path: ROUTES.highAndLowResult,
                element: <HighAndLowResult />,
              },
              {
                path: ROUTES.highAndLowRanking,
                element: <HighAndLowRanking />,
              },
              // 통계
              {
                path: ROUTES.statisticsMain,
                element: <StatisticsMain />,
              },
            ],
          },
        ],
      },
      {
        path: ROUTES.signin,
        element: <SignInPage />,
      },
      {
        path: '/signIn',
        element: <SignInPage />,
      },
      {
        path: ROUTES.signup,
        element: <SignUpPage />,
      },
      {
        path: ROUTES.resetPassword,
        element: <ResetPasswordPage />,
      },
      {
        path: ROUTES.updateAccount,
        element: <UpdateAccountPage />,
      },

      { path: ROUTES.naverRegisterStart, element: <NaverRegisterStartPage /> },
      { path: ROUTES.naverRegisterToken, element: <NaverRegisterTokenPage /> },

      {
        path: ROUTES.guide,
        children: [{ path: ROUTES.startStoreGuide, element: <SmartstoreGuidePage /> }],
      },
      { path: ROUTES.intro, element: <IntroPage /> },
      // 설문조사
      { path: `${ROUTES.surveys}/:id`, element: <SurveyPage /> },
      // ----------------------------------------------------------------------------------
      { path: ROUTES.error, element: <ErrorPage /> },
      { path: ROUTES.makeName, element: <MakeNamePage /> },
      { path: ROUTES.changeName, element: <ChangeNamePage /> },
      // { path: ROUTES.diagnoseProduct, element: <DiagnoseProductPage /> },
      {
        element: <FlexRootlayout />,
        children: [
          {
            element: <ProtectedRoute />,
            children: [
              {
                path: `${ROUTES.MarketConnectionComplete}/:englishMarketName`,
                element: <MarketConnectionCompletePage />,
              },
              {
                path: ROUTES.aiChatBot,
                element: <AIChatBotPage />,
              },
              {
                // path: '/news-briefing/:group
                path: `${ROUTES.newsBriefing}/:group`,
                element: <NewsBriefingPage />,
              },
            ],
          },
        ],
      },
      {
        element: <FlexRootlayout />,
        children: [
          {
            element: <ProtectedRoute />,
            children: [
              {
                path: `${ROUTES.MarketConnectionComplete}/:englishMarketName`,
                element: <MarketConnectionCompletePage />,
              },
              {
                path: ROUTES.aiChatBot,
                element: <AIChatBotPage />,
              },
              {
                // path: '/news-briefing/:group/:id',
                path: `${ROUTES.newsBriefing}/:group`,
                element: <NewsBriefingPage />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    Component: YearEndPage,
    path: ROUTES.yearEnd,
    errorElement: <ErrorPage />,
  },
]);
